export const formatReadTime = (minutes) => {
  if (minutes < 1) {
    return '< 1 min read';
  } else if (minutes < 60) {
    return `${minutes} min read`;
  } else {
    const hours = Math.floor(minutes / 60);
    const remainingMins = minutes % 60;
    if (remainingMins === 0) {
      return `${hours} hr read`;
    }
    return `${hours} hr ${remainingMins} min read`;
  }
};
